import { render, staticRenderFns } from "./PropertyListingBackup2024.vue?vue&type=template&id=fade4702"
import script from "./PropertyListingBackup2024.vue?vue&type=script&lang=js"
export * from "./PropertyListingBackup2024.vue?vue&type=script&lang=js"
import style0 from "./PropertyListingBackup2024.vue?vue&type=style&index=0&id=fade4702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports